"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var tableSelectors_1 = require("../tableSelectors");
var inputStyles = {
    width: '100%',
    border: 'none',
    WebkitAppearance: 'none',
    font: 'inherit',
    color: 'currentColor',
    textAlign: 'inherit',
    margin: 0,
    padding: 0,
    background: 'none',
    letterSpacing: 'inherit'
};
var TextAreaField = function (_a) {
    var schema = _a.schema, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex, columnRowIndex = _a.columnRowIndex, value = _a.value, currentTableObj = _a.currentTableObj, editMode = _a.editMode;
    var textAreaRef = (0, react_1.useRef)(null);
    var _b = react_1.default.useState(value), textValue = _b[0], setTextValue = _b[1];
    var _c = (0, react_1.useState)('auto'), textAreaHeight = _c[0], setTextAreaHeight = _c[1];
    var _d = (0, react_1.useState)('auto'), parentHeight = _d[0], setParentHeight = _d[1];
    (0, react_1.useEffect)(function () {
        var _a, _b;
        setParentHeight("".concat((_a = textAreaRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight, "px"));
        setTextAreaHeight("".concat((_b = textAreaRef.current) === null || _b === void 0 ? void 0 : _b.scrollHeight, "px"));
    }, [textValue]);
    react_1.default.useEffect(function () {
        setTextValue(value);
    }, [value]);
    return (react_1.default.createElement("div", { style: {
            minHeight: parentHeight
        } },
        react_1.default.createElement("textarea", { ref: textAreaRef, onChange: function (e) {
                var _a;
                var newTextValue = e.target.value;
                setTextValue(newTextValue);
                if (currentTableObj) {
                    var widgetProps = currentTableObj.customOptions.widgetProps;
                    var rowsToChange = __spreadArray([], (0, tableSelectors_1.generateEmptyRowValuesBySchema)(schema, widgetProps.rows), true);
                    rowsToChange[rowIndex][columnIndex][columnRowIndex].value = newTextValue;
                    currentTableObj.setTableRowsProps(rowsToChange);
                }
                setTextAreaHeight('auto');
                setParentHeight("".concat((_a = textAreaRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight, "px"));
            }, value: textValue, rows: 1, style: __assign(__assign({}, inputStyles), { resize: 'none', height: textAreaHeight, boxShadow: editMode ? '0 0 0 2px #808080' : 'none' }) })));
};
exports.default = TextAreaField;
//# sourceMappingURL=TextAreaField.js.map